"use client"

import LoadingIndicator from "@/components/LoadingIndicator"
import {
  useCallback 
} from "react"
import CategoryFilter from "./categoryFilter"
import ColorFilter from "./colorFilter"
import ItemList from "./itemList"
import ItemModal from "./itemModal"
import MobileFilter from "./mobileFilter"
import classes from "./realWeddingPage.module.css"
import {
  useRealWeddingPage 
} from "./useRealWeddingPage"

const RealWeddingPage = () => {
  const {
    colors,
    categories,
    items,
    selectedColorIds,
    setSelectedColorIds,
    selectedCategoryId,
    setSelectedCategoryId,
    itemModalVisible,
    setItemModalVisible,
    selectedItem,
    setSelectedItem,
    storeConfig,
    loading,
  } = useRealWeddingPage({})

  const onItemClick = useCallback(
    (item) => {
      setSelectedItem(item)
      setItemModalVisible(true)
    },
    [setItemModalVisible, setSelectedItem]
  )

  const onClose = useCallback(() => {
    setItemModalVisible(false)
  }, [setItemModalVisible])

  const onApplyFilter = useCallback((colorIds, categoryId) => {
    setSelectedColorIds(colorIds)
    setSelectedCategoryId(categoryId)
  }, [])

  const maybeLoadingIndicator = loading ? (
    <LoadingIndicator>Loading...</LoadingIndicator>
  ) : null

  return (
    <div className={classes.root}>
      {colors && categories && (
        <MobileFilter
          colors={colors}
          categories={categories}
          onApplyFilter={onApplyFilter}
          selectedColorIds={selectedColorIds}
          selectedCategoryId={selectedCategoryId}
        />
      )}
      <ColorFilter
        colors={colors}
        setSelectedColorIds={setSelectedColorIds}
        selectedColorIds={selectedColorIds}
      />

      <CategoryFilter
        categories={categories}
        setSelectedCategoryId={setSelectedCategoryId}
        selectedCategoryId={selectedCategoryId}
      />

      <div className={classes.itemsContainer}>
        <ItemList
          items={items}
          onItemClick={onItemClick}
          loading={loading}
        />
      </div>
      {maybeLoadingIndicator}
      {selectedItem && (
        <ItemModal
          storeConfig={storeConfig}
          item={selectedItem}
          onClose={onClose}
          open={itemModalVisible}
        />
      )}
    </div>
  )
}

export default RealWeddingPage
